const KIOSK_SUBDOMAINS = (process.env.REACT_APP_KIOSK_SUBDOMAIN || 'orbiter')
    .toLowerCase()
    .split(',')
    .map((subdomain) => subdomain.trim())
    .filter(Boolean);

export const isKioskHostname = (hostname: string) => {
    const h = hostname.toLowerCase();

    return KIOSK_SUBDOMAINS.some((subdomain) => h.startsWith(`${subdomain}.`));
};